import { Component, Injector } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mj_Detail } from '../mj_detail/mj_detail';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { HatComponent } from '../component/hat';
import { LancetsComponent } from '../component/lancets';
import { LineSvgComponent } from '../component/linesvg';
import { UserStarComponent } from '../component/userstar';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from '../dashboard/dashboard';
import { DetailBadge } from '../detail_badge/detail_badge';
import { HrGraphCampionatiPage } from '../hr_graphcampionati/hr_graphcampionati';
import { HrProfiloUtentePage } from '../hr_profiloutente/hr_profiloutente';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
/*@NgModule({
  imports: [RoundProgressModule]
})*/
@Component({
  selector: 'page-hr_table',
  templateUrl: 'hr_table.html',
})
export class HrTablePage extends Util {
  grafico: any = {};
  campionato: any;
  girone: any;
  index_click: any;
  table: any;
  filter_params: any = {};
  premuto_filtra = false;
  showDownloadTracciati: boolean = false;
  constructor(public navCtrl: NavController, public translate: TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController, hat: HatComponent, lancets: LancetsComponent, linesvg: LineSvgComponent, userstar: UserStarComponent) {
    super(injector, loading);
    this.grafico = this.navParams.get('grafico');
    this.campionato = this.navParams.get('campionato');
    this.girone = this.navParams.get('girone');
    this.index_click = this.navParams.get('index_click');
    this.filter_params = this.navParams.get('filter_params');
    this.premuto_filtra = this.navParams.get('premuto_filtra');
    this.showDownloadTracciati = this.navParams.get('showDownloadTracciati');
    // console.log('----',this.index_click);
    this.refreshpage();
    // this.timeout_loop();

  }

  timeout_loop() {
    setTimeout(() => {
      this.refreshpage();
      this.timeout_loop();
    }, 1000 * 60 * 2);
  }

  refreshpage() {
    var req = this.grafico.id + '/' + this.campionato + '/' + this.girone;
    if (this.index_click == 0 || (this.index_click != undefined && this.index_click != ''))
      req = this.grafico.id + '/' + this.campionato + '/' + this.girone + '/' + this.index_click;
    // console.log(req);

    if (this.premuto_filtra == false) {
      this.GetRequest('hr_dettagli_grafico', req).then((res: any) => {
        // console.log(res);
        this.table = res;
      }).catch((err) => {
        console.error(err);
      })
    }
    else {

      this.filter_params = this.navParams.get('filter_params');
      this.PostRequest('hr_dettagli_grafico', '', { index: this.index_click, grafico_id: this.grafico.id, cid: this.campionato, from_date: this.filter_params.from_date, to_date: this.filter_params.to_date, gironi: this.filter_params.gironi, mjs: this.filter_params.mjs }, true, true).then((res) => {
        console.log(res);
        this.table = res;
        // this.disegna_grafici(res);
      }).catch((e) => {
        console.error(e);
      })
    }
  }

  export() {
    if (this.premuto_filtra == false) {
      var req = this.grafico.id + '/' + this.campionato + '/' + this.girone;
      if (this.index_click == 0 || (this.index_click != undefined && this.index_click != ''))
        req = this.grafico.id + '/' + this.campionato + '/' + this.girone + '/' + this.index_click;
      this.GetRequest('hr_esporta_grafico', req).then((x: any) => {
        // console.log(x);
        if (x != null && x.base64 != null) {
          const linkSource = `data:application/vnd.ms-excel;base64,${x.base64}`;
          const downloadLink = document.createElement("a");
          const fileName = "esportazione_dati_eydlab.xls";

          downloadLink.href = linkSource;
          // downloadLink.target = '_blank';
          downloadLink.download = fileName; 
          downloadLink.click();
        }
      }).catch((err) => {
        console.error(err);
      })
    } else {
      this.PostRequest('hr_esporta_grafico', '', { index: this.index_click, grafico_id: this.grafico.id, cid: this.campionato, from_date: this.filter_params.from_date, to_date: this.filter_params.to_date, gironi: this.filter_params.gironi, mjs: this.filter_params.mjs }, true, true).then((x: any) => {

        if (x != null && x.base64 != null) {
          const linkSource = `data:application/vnd.ms-excel;base64,${x.base64}`;
          const downloadLink = document.createElement("a");
          const fileName = "esportazione_dati_eydlab.xls";

          downloadLink.href = linkSource;
          // downloadLink.target = '_blank';
          downloadLink.download = fileName;
          downloadLink.click();
        }
      }).catch((err) => {
        console.error(err);
      })

    }
  }
  open_profiloutente(utente) {
    this.navCtrl.push(HrProfiloUtentePage, { utente: utente, campionato: this.campionato, showDownloadTracciati: this.showDownloadTracciati });
  }



  back() {

    this.navCtrl.pop({ animate: false });

  }

}



// WEBPACK FOOTER //
// ./src/pages/hr_table/hr_table.ts